module.exports = __webpack_public_path__ + "img/logo.0dfe78a5.svg";